<template>
  <div class="cg-data-table-warp">
    <a-table
      bordered
      v-if="ColumnDefines"
      :size="size"
      :columns="ColumnDefines"
      :data-source="recListData"
      :pagination="false"
      :scroll="{ x: true }"
      :rowKey="(record, index) => index"
      :row-selection="RowSelection"
      @change="OnTableChange"
    >
      <template
        v-for="(item, index) in colInfoList"
        :slot="'slot-' + item.ColName"
        slot-scope="text, record"
      >
        <slot
          :name="'col-' + item.ColName.toLowerCase()"
          :recData="record"
          :colInfo="item"
        >
          <cg-table-cell
            :key="index"
            :colInfo="item"
            :data="record"
            @sortClick="OnSortClick"
          ></cg-table-cell>
        </slot>
      </template>
    </a-table>
  </div>
</template>
<script>
import CgTableCell from "./TableCell";
export default {
  components: { CgTableCell },
  props: {
    colInfoList: {
      type: Array,
      default: () => [],
    },
    recListData: {
      type: Array,
      default: () => [],
    },
    keyColName: {
      type: String,
      default: "small",
    },
    allowModify: {
      type: Boolean,
      default: false,
    },
    allowDell: {
      type: Boolean,
      default: false,
    },
    allowView: {
      type: Boolean,
      default: true,
    },
    isShowRowOpt: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      SelectedRowKeys: [],
      ColumnDefines: null,
    };
  },
  computed: {
    RowSelection() {
      //多选行存在
      if (this.GetMultiSelectRowColInfo()) {
        return {
          selectedRowKeys: this.SelectedRowKeys,
          onChange: this.OnSelectChange,
        };
      }

      return null;
    },
  },
  watch: {
    recListData: {
      handler() {
        this.SelectedRowKeys = this.GetSelectedRowKeys();

        this.InitTable();
      },
      deep: true,
    },
    // 是否需要界面显示否隐藏？这个其实有点疑问
    // 应该在界面渲染前，控件是否显示，界面显示后就不允许再控件。
    // 不然会造成界面偏移
    // isShowRowOpt() {
    //   this.ColumnDefines = this.GetColumnDefines();
    // },
    //字段信息的变化要实时渲染
    colInfoList: {

      handler() {

        this.InitTable();
      }
    }
  },
  methods: {
    //获取多选行控件列信息
    GetMultiSelectRowColInfo() {
      return this.colInfoList.find((item) => !!item.SelectedRecData);
    },
    GetColumnDefines() {
      
      let _columnDefines = [];

      let _colInfoList = this.colInfoList.slice();

      if (!this.isShowRowOpt) {
        _colInfoList = _colInfoList.filter((item) => item.ColName !== "cmn_userform_opt");
      }

      _colInfoList.forEach((item) => {
        if (item.ColControlName === "MultiSelectRow") {
        } else {
          let _column = {
            title: item.ColTitle,
            dataIndex: item.ColName,
            width: (item.ColWidth || 80) * 1,
            sorter: item.IsCanSort === "1",
            align: item.ColAlign || "left",
            scopedSlots: { customRender: 'slot-' + item.ColName },
          };

          _columnDefines.push(_column);
        }
      });

      return _columnDefines;
    },
    //获取选中行keys
    GetSelectedRowKeys() {
      let _keys = [];

      let _colInfo = this.GetMultiSelectRowColInfo();

      if (_colInfo) {
        this.recListData.forEach((recData, index) => {
          let _recID = recData[this.keyColName];

          if (_colInfo.SelectedRecData[_recID]) {
            _colInfo.SelectedRecData[_recID] = recData;
            _keys.push(index);
          }
        });
      }

      return _keys;
    },
    //选中行改变时
    OnSelectChange(selectedRowKeys) {
      this.$emit("rowSelectChange", selectedRowKeys);

      this.SelectedRowKeys = this.GetSelectedRowKeys();
    },
    OnTableChange(pagination, filters, sorter, { currentDataSource }) {
      this.$emit("titleSort", sorter);
    },
    OnViewClick(record) {
      this.$emit("viewClick", record);
    },
    OnUpdateClick(record) {
      this.$emit("updateClick", record);
    },
    OnDeleteClick(record) {
      this.$emit("deleteClick", record);
    },
    OnSortClick(sorter) {
      this.$emit("sortClick", sorter);
    },
    InitTable() {
      clearTimeout(this.ResizeTimeout);

      this.ResizeTimeout = setTimeout(() => {

        this.ColumnDefines = this.GetColumnDefines();
      }, 200);
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.InitTable();
    });

    this.InitTable();
  },
};
</script>
